import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MessageService } from '../../../services/message.service';
import { Request } from '../../../models/request.model';
import { RequestService } from '../../../../request/request.service';
import { UserService } from '../../../services/user.service';
import { User } from '../../../../shared/models/user.model';

@Component({
  standalone: false,
  selector: 'app-request-list-modal',
  templateUrl: './request-list-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class RequestListModalComponent {
  requests: Array<Request> = [];
  selectedRequests: Array<Request> = [];
  selectedRequestIds: Array<number> = [];
  users: Array<User> = [];
  filteredUsers: Array<string> = [];  
  form: FormGroup;
  searchTerm: string;
  userTitle: string = 'Izaberi korisnika';
  userId: string;
  isListEmpty: boolean;
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private requestService: RequestService,
              private message: MessageService,
              private userService: UserService,
              private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      userId: '',
    });

    this.getUsers();
    this.getListOfOfferWorkRequests();

    this.form.valueChanges.subscribe(res => {
      if (res.userId && res.userId.length > 0) {
        this.userId = this.users[this.users.findIndex(item => item.name === res.userId)].id;
      } else {
        this.userId = '';
        this.userTitle = 'Izaberi korisnika';
      }

      this.getListOfOfferWorkRequests();
    });
  }

  getListOfOfferWorkRequests(): void {
    this.requestService.getListOfOfferWorkRequests(0, 50, this.userId, null, this.searchTerm).subscribe(
      res => {
        this.requests = [];

        for (let item of res.results) {
          this.requests.push(new Request(item));
        }
        this.isListEmpty = res.count === 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelectRequest(request: Request): void {
    const index = this.selectedRequestIds.indexOf(request.workRequestId);
    if (index !== -1) {
      this.selectedRequestIds.splice(index, 1);
      this.selectedRequests.splice(index, 1);
    } else {
      this.selectedRequests.push(request);
      this.selectedRequestIds.push(request.workRequestId);
    }
  }

  getUsers(): void {
    const roles = ['Odgovorni projektant', 'Tehnički direktor', 'Šef sektora razvoja', 'Customer service'];

    this.userService.getUsers(0, 50, undefined, roles, true).subscribe(
      res => {
        this.users = [];
        this.filteredUsers = res.results.map(item => item.name);

        for (let person of res.results) {
          this.users.push(new User(person));
        }

        this.isListEmpty = res.count === 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSave(): void {
    this.responseChanged.emit(this.selectedRequests);
  }

  onSearch(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.getListOfOfferWorkRequests();
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
